import { createStore, applyMiddleware } from 'redux'; // Importing functions to create Redux store and apply middleware
import reducer from './reducer'; // Importing the combined reducer
import thunkMiddleware from 'redux-thunk'; // Importing middleware to handle async actions
import { composeWithDevTools } from 'redux-devtools-extension'; // Enables Redux DevTools integration

// ==============================|| REDUX - MAIN STORE ||============================== //

// Combine middleware with Redux DevTools
const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware));

// Create Redux store with reducer and enhancer
const store = createStore(reducer, composedEnhancer);

// Placeholder for persister (used with redux-persist if needed)
const persister = '';

// Export store and persister
export { store, persister };
